import React from "react"

const Contact = () => {
  return (
    <div>
      <h2>Contact us</h2>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Obcaecati
        inventore adipisci nulla facere vel sunt quasi et in natus consequatur
        temporibus, molestiae sint cum beatae repellat aut velit ipsum sed!
      </p>
    </div>
  )
}

export default Contact
